import React from "react";
import styles from "./styles/QurealViewerBox.module.css";
import { useMedia } from "react-use";
import { useMutation } from "react-query";
import { useQurealActions } from "qureal-editor";
import { QurealViewer } from "qureal-editor";
import { Button } from "antd";
import LOGO from "../../media/imgs/1_logo_horizontal.png";
import {
    DownloadOutlined,
    ShareAltOutlined,
    SyncOutlined,
    ThunderboltOutlined,
    EyeOutlined,
    CloseOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import GenerationLoading from "./GenerationLoading";
import { getEditURL } from "../../_helpers/editor";
import log from "cslog";
import QurealOneViewer from "../../showwrapper/QurealOneViewer";
import NewGenerationLoading from "./NewGenerationLoading";

function QurealViewerBox({
    item,
    slug_field = "id",
    preview,
    org,
    person,
    is_template,
    prefill,
    isMobile,
    status,
    setStatus,
    loading,
    url,

    actionRef,
    download,
    share,
    width = false,
    height = false,
    backgroundColor = "auto",
    wrapper_styles = {},
    gs_overrides = {},
    bookPrefill = [],
    onRender = () => {},
}) {
    // const { actionRef, download, share } = useQurealActions();

    log.d(prefill, "QurealViewerBox prefill");

    log.d(status, "QurealViewerBox status");

    return (
        <div
            className={styles.left_box}
            style={{
                backgroundColor: backgroundColor,
                ...wrapper_styles,
            }}
        >
            {/* <p>K: {item.type}:{item[slug_field]}</p> */}

            <div
                className={styles.web_box}
                style={{
                    width: width || (isMobile ? "93vw" : "85vh"),
                    height: height || (isMobile ? "93vw" : "85vh"),
                }}
            >
                <QurealOneViewer
                    slug={item[slug_field]}
                    type={is_template ? "template" : "creation"}
                    creation_type={item.type}
                    preview={preview}
                    org={org}
                    person={person}
                    isMobile={isMobile}
                    prefill={prefill}
                    organization={org}
                    style={{
                        width: width || (isMobile ? "93vw" : "85vh"),
                        height: height || (isMobile ? "93vw" : "85vh"),
                        outline: "none",
                        // border: "1px solid #777",
                        border: "1px solid transparent",
                    }}
                    actionRef={actionRef}
                    gs_overrides={gs_overrides}
                    status={status}
                    setStatus={setStatus}
                    download={download}
                    share={share}
                    // loadingRender={loadingRender}
                    loadingRender={
                        <div
                            style={{
                                width: width || (isMobile ? "93vw" : "85vh"),
                                height: height || (isMobile ? "93vw" : "85vh"),
                            }}
                        >
                            <NewGenerationLoading />
                        </div>
                    }
                    bookPrefill={bookPrefill}
                    onRender={onRender}
                />

                {/* <QurealViewer
                    slug={item[slug_field]}
                    preview={preview}
                    style={{
                        width: width || (isMobile ? "93vw" : "85vh"),
                        height: height || (isMobile ? "93vw" : "85vh"),
                        outline: "none",
                        // border: "1px solid #777",
                        border: "1px solid transparent"
                    }}
                    organization={org}
                    person={person}
                    actionRef={actionRef}
                    type={is_template ? "template" : "creation"}
                    creation_type={item.type}
                    fit={true}
                    // background="white"
                    background={backgroundColor}
                    onInit={(data) => {
                        // alert(JSON.stringify(data))
                        // log.d(data, "QurealViewerBox onInit");
                    }}
                    prefill={prefill}
                    onStatusUpdate={(data) => {
                        // alert("status updated")
                        setStatus(data);
                    }}
                // is_local={true}
                /> */}

                {loading && <GenerationLoading />}
            </div>

            {!isMobile && (
                <div className={styles.bottom_bar}>
                    <img src={LOGO} className={styles.logo} />

                    <div className={styles.bottom_bar_btn_group}>
                        {!is_template && (
                            <a
                                // href={editor_url}
                                href={getEditURL(item.id)}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button>Edit</Button>
                            </a>
                        )}
                        <a href={url} target="_blank" rel="noreferrer">
                            {isMobile ? (
                                <Button icon={<EyeOutlined />}></Button>
                            ) : (
                                <Button icon={<EyeOutlined />}>
                                    {/* Full page view */}
                                </Button>
                            )}
                        </a>
                        <Button
                            onClick={download}
                            // type="primary"
                            loading={status?.download}
                            icon={<DownloadOutlined />}
                        >
                            {/* Download */}
                        </Button>
                        <Button
                            onClick={share}
                            // type="primary"
                            loading={status?.share}
                            icon={<ShareAltOutlined />}
                        >
                            {/* Share */}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default QurealViewerBox;
